  // handle checking of shipping cost
(function ($) {
  $(document).ready(function(){
    $('form select[name=id]').on('change', function() {
     
    });
    $('#shipping-calculator h4').text("Check shipping cost for " + $('h1.product_name').text());
                                      
	var country = $('#address_country option:selected').text();
    var province = $('#address_province option:selected').text() || '';
    var zipcode = '';

    $('a#shipping_cost_button').fancybox({
      'maxWidth': '900px',
      'minHeight': '470px'
    });
    
    $('#address_country').on('change', function() {
    	country = $('#address_country option:selected').text();
    });
    
    $('#address_province').on('change', function() {
   		province = $('#address_province option:selected').text();
    });
        
    $('#shipping_cost #get-rates-submit').unbind('click');
    $('#shipping_cost #get-rates-submit').on("click", function(){
      zipcode = $('#address_zip').val();

      $.fancybox.showLoading();
		$.ajax({
           type: 'GET',
           url: '/cart.js',
           dataType: 'json',
         }).success(function (json) {
          var cart = {};
          
          json.items.forEach(function (item) {
          	cart[item.id] = item.quantity;
          });
          
          var oldCart = Object.assign({}, cart);
         
          for (var prop in cart) {
          	cart[prop] = 0;
          }
          
          var variantId = $('form select[name=id] option:selected').attr('value');
          if(!variantId){
          	variantId = $('form input[name=id]').val();
          }
                    
          cart[variantId] = $('#quantity').val();
          
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'text',
            data: { updates: cart },
          }).done(function (data) {
            $.ajax({
              type: 'GET',
              dataType: 'json',
              url: '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + zipcode + '&shipping_address%5Bcountry%5D=' + country + '&shipping_address%5Bprovince%5D=' + province
            }).done(function (rates) {
              	$.fancybox.hideLoading();
                var sR = rates ? rates.shipping_rates : [];
              
                var result = sR.map(function (item) {
                  return '<li class="shippingVariant">'+ item.presentment_name + ' at <b>$' + item.price +'</b></li>';
                });
                var list = result ? '<ul>'+ result.join('') + '</ul>' : 'No shipping rates';
              	$('#shipping_cost_result').html('');
                $('#shipping_cost_result').append(
                '<p>There are ' + sR.length + ' shipping rates available.</p>' + list);
				
                oldCart[variantId] = 0;
              	$.ajax({
                  type: 'POST',
                  dataType: 'text',
                  url: '/cart/update.js',
                  data: { updates: oldCart }
                });
              
              	//end done function
              }).error(function() {
                  $('#shipping_cost_result').html('');
                      $('#shipping_cost_result').append('<p>No shipping options found!</p>');
                  $.fancybox.hideLoading();
                });
            
            	//end success
          }).error(function() {
            $('#shipping_cost_result').html('');
                $('#shipping_cost_result').append('<p>No shipping options found!</p>');
          	$.fancybox.hideLoading();
          });
            
            //end done function
          }).error(function() {
            $('#shipping_cost_result').html('');
                $('#shipping_cost_result').append('<p>No shipping options found!</p>');
          	$.fancybox.hideLoading();
          });
          
          //end click handler
         });      
  });
})(jQuery);
